export default __webpack_public_path__ + "static/media/feather.d8a3fe11.svg";